import api from "../api";
import authService from "./AuthService";
import axios from "axios";

const END_POINT = "/api/locations";

/**
 * This method will load all locations from the database with a get http call
 * @returns {} it is returning a promise with all locations
 */
export async function getAllLocationsHttp() {
  return await api.get(`${END_POINT}`);
}

/**
 * This method will load all locations from the database with a get http call
 * @returns {} it is returning a promise with all locations
 */
export async function getAllNotHiddenLocationsHttp() {
  return await api.get(`${END_POINT}/not-hidden`);
}

/**
 *  This method will load locations depending of page, size and search parameters with a get http call
 *
 * @param  {int} page page number that will be load
 * @param  {int} size number of locations that will be load (represents LIMIT in sql)
 * @param  {String} search only locations containing 'search' will be load
 * @returns {} it is returning a promise with locations depending of page, size and search parameters
 */
export async function getAllLocationsPaginationHttp(page, size, search) {
  return await api.get(`${END_POINT}/pagination`, {
    params: {
      page: page,
      size: size,
      search: search,
    },
  });
}

/**
 * This method will give the number of locations containing 'search' with a get http call
 *
 * @param  {String} search only locations containing 'search' will be counted
 * @returns {} it is returning a promise with the number of locations containing 'search'
 */
export async function getCountHttp(search) {
  return await api.get(`${END_POINT}/count`, {
    params: {
      search: search,
    },
  });
}

/**
 * This method is adding a location from the database with a post http call
 *
 * @param  {Object - loactionDto} location object that we want to add from the database
 * @returns {} it is returning a promise with the added location
 */
export async function addLocationHttp(location) {
  return await api.post(`${END_POINT}`, {
    city: location.city,
    color: location.color.hex,
    version: location.version,
  });
}

/**
 * This method is updating a location from the database with a put http call
 *
 * @param  {Object - loactionDto} location object that we want to update from the database
 * @returns {} it is returning a promise with the updated location
 */
export async function updateLocationHttp(location) {
  return await api.put(`${END_POINT}`, location);
}

/**
 * This method is removing a location from the database with a delete http call
 *
 * @param  {long} id id of the location we want to remove from the database
 * @returns {} it is returning a promise. You will have 202 status if the location was deleted successfully.
 */
export async function deleteLocationHttp(id) {
  return await api.delete(`${END_POINT}/${id}`);
}

/**
 * This method will fetch locations from the webservice Wdg2 with a get http call
 * @param  {Object - LogInUser} logInUser user dg2
 */
export async function fetchAllLocationsDG2Http(logInUser) {
  return await axios.get(`${process.env.VUE_APP_BASE_URL}${END_POINT}/dg2`, {
    headers: {
      Authorization: authService.getBearerToken(),
      "X-AUTH-TOKEN": `${logInUser.email}:${logInUser.password}`,
    },
  });
}
